import { splitWord } from '@/utils';

export const LETTERS = splitWord('claridenhof');
